import React from 'react';

const EventHero = () => {
  return (
    <section className="relative bg-white pt-16">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="pt-10 md:pt-14 lg:pt-20 pb-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Header Content */}
            <div className="text-center lg:text-left">
              <h1 className="text-4xl md:text-5xl font-bold text-apple-gray-900 mb-4">
                Guest Speaker Event
              </h1>
              <h2 className="text-2xl md:text-3xl font-semibold text-apple-gray-700 mb-2">
                Universidad de Cartagena
              </h2>
              <p className="text-xl text-apple-gray-600 mb-8">
                Navigating Taxes, Contracts, Labor Safety, and Other Entrepreneurial Challenges
              </p>
            </div>

            {/* Event Poster */}
            <div className="flex justify-center lg:justify-end">
              <div className="bg-white rounded-xl shadow-sm border border-apple-gray-200 overflow-hidden max-w-lg">
                <img
                  src="/NavigatingEntrepreneurship/Poster.webp"
                  width="794"
                  height="1123"
                  alt="Event Poster - Navigating Entrepreneurship Challenges"
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventHero;